import { Component, inject, OnInit } from '@angular/core';
import { DashboardWrapperComponent } from '../../components/dashboard-wrapper/dashboard-wrapper.component';
import { LoaderComponent } from 'app/components/loader/loader.component';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { RedeemThankYouPopupComponent } from './components/redeem-thank-you-popup/redeem-thank-you-popup.component';
import { TranslateModule } from '@ngx-translate/core';
import { RewardsService } from './rewards.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-rewards',
    standalone: true,
    imports: [
        DashboardWrapperComponent,
        LoaderComponent,
        ReactiveFormsModule,
        CommonModule,
        TranslateModule,
    ],
    templateUrl: './rewards.component.html',
    styleUrl: './rewards.component.scss',
})
export class RewardsComponent implements OnInit {
    private _rewardService = inject(RewardsService);
    form: FormGroup;
    err: string = '';
    refSummry: any;
    totalChecksToShow = 4;
    completedChecks = [];
    incompleteChecks = [0, 0, 0, 0];
    isLoading: boolean = false;

    constructor(
        private fb: FormBuilder,
        private dialog: MatDialog,
        private _toastr: ToastrService
    ) {
        this.form = this.fb.group({
            code: [
                '',
                [
                    Validators.required,
                    Validators.minLength(6),
                    Validators.maxLength(14),
                ],
            ],
        });

        this.form.get('code')?.valueChanges.subscribe(() => {
            const codeControl = this.form.get('code');

            if (codeControl && codeControl.valid) {
                this.err = '';
            }
        });
    }

    ngOnInit(): void {
        this.isLoading = true;
        this._rewardService.getReferralSummry().subscribe({
            next: (data) => {
                if (data?.totalCount) {
                    let count = Number(data?.totalCount) % 5;
                    this.completedChecks = new Array(count).fill(0);
                    this.incompleteChecks = new Array(
                        this.totalChecksToShow - count
                    ).fill(0);
                }
                this.isLoading = false;
            },
            error: (err) => {
                console.log('error', err.message);
                this.isLoading = false;
            },
        });
    }

    onInputChange(event: Event) {
        const input = event.target as HTMLInputElement;
        const cleanValue = input.value.replace(' ', '');

        if (cleanValue !== input.value) {
            input.value = cleanValue;
            this.form.get('code')?.setValue(cleanValue, { emitEvent: false });
        }

        const codeControl = this.form.get('code');
        if (codeControl) {
            this.err = '';
        }
    }

    submitCode() {
        this.err = '';
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            const codeControl = this.form.get('code');
            if (codeControl?.hasError('required')) {
                this.err = 'REDEEM.ERROR.REQUIRED';
            } else if (codeControl?.hasError('minlength')) {
                this.err = 'REDEEM.ERROR.MIN_LENGTH';
            } else if (codeControl?.hasError('maxlength')) {
                this.err = 'REDEEM.ERROR.MAX_LENGTH';
            } else {
                this.err = 'REDEEM.ERROR.INVALID';
            }
            return;
        }

        const code = this.form.value.code;

        try {
            this._rewardService.redeemCode(code).subscribe({
                next: (data) => {
                    this.form.reset();
                    if (data.id) this.showThankYouPop();
                },
                error: (err) => {
                    const errCode = err?.error?.code;
                    if (errCode) {
                        this.setError(errCode);
                    } else {
                        this.err = 'REDEEM.ERROR.SERVER';
                    }
                },
            });
        } catch (err) {
            this._toastr.error(err.message);
        }
    }

    setError(errCode: string) {
        switch (errCode) {
            case '40003040':
                this.err = 'REDEEM.ERROR.INVALID_REDEEMCODE';
                break;
            case '40003041':
                this.err = 'REDEEM.ERROR.EXPIRED_REDEEMCODE';
                break;
            case '40003042':
                this.err = 'REDEEM.ERROR.LIMIT_EXCEED_REDEEMCODE';
                break;
            case '40003043':
                this.err = 'REDEEM.ERROR.NEW_USER_ONLY_ALLOW';
                break;
            case '40003022':
                this.err = 'REDEEM.ERROR.INVALID_REDEEMCODE';
                break;
            case '40003023':
                this.err = 'REDEEM.ERROR.PROMOCODE_ALREADY_EXISTS';
                break;
            case '40003024':
                this.err = 'REDEEM.ERROR.PROMOCODE_NOT_UPDATE';
                break;
            default:
                this.err = 'REDEEM.ERROR.SERVER';
        }
    }

    get code() {
        return this.form.get('code');
    }

    showThankYouPop() {
        this.dialog.open(RedeemThankYouPopupComponent, {
            width: '100%',
            maxWidth: '500px',
            height: '302px',
            panelClass: 'redeem-thank-popup',
        });
    }
}
